import { GameTicketProperties } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/properties/GameTicketProperties";
/**
 * TicketPortraitProperties.ts
 */
export class TicketPortraitProperties extends GameTicketProperties {
    constructor() {
        super();
        this.position.set(11, 364);
        this.symbolPanelProperties.position.set(131, 131);
    }
}
//# sourceMappingURL=TicketPortraitProperties.js.map